



















































































import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { Element, ElementStatus, Product } from '@/models'
import { MutationTypes } from '@/store/mutation-types'
import { ActionTypes } from '@/store/action-types'
import { CvValueUtils } from '@/utils/cv-value-utils'
import { CV_VALUE_COUNTRY, CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT, CV_VALUE_PRODUCTION_MODE, CV_VALUE_EDUCATION, CV_VALUE_TYPE_PROD, DEFAULT_ICON_PRODUCT } from '@/utils/constants'
import _ from 'lodash'
import { Utils } from '@/utils'

@Component({
  name: 'ProductDetail',
  components: {
    DetailTab: () => import('@/components/productDetail/DetailTab.vue'),
    StructureTab: () => import('@/components/productDetail/StructureTab.vue'),
    TypeIcon: () => import('@/components/TypeIcon.vue')
  }
})
export default class ProductDetail extends Vue {
  private CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT = CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT
  private Utils = Utils

  private product: Product = { id: '', name: '', code: '', type: '', project: '', status: '', metadata: {}, createdOn: '', updatedOn: '', autoGenerate: false, hasElements: false, synchronizeEc: true, elements: [] }
  private digitalCourse: Product = { id: '', name: '', code: '', type: '', project: '', status: '', metadata: {}, createdOn: '', updatedOn: '', autoGenerate: false, hasElements: false, synchronizeEc: true, elements: [] }
  private routeProductId = this.$router.currentRoute.params.productId || ''
  // @ts-ignore
  private tabIndex = parseInt(this.$router.currentRoute.query.tab) || 0

  private elementStatusFiles: ElementStatus[] = []
  private elementStatusFilesGrouped: any = null

  async created() {
    this.loadElementTypes()
    this.loadCountry()
    this.loadBusinessUnit()
    this.loadProductionModes()
    this.loadEducationLevels()
    this.loadProductTypes()
    await this.loadFileStatus()
    this.loadProduct()
  }

  get isAutoGenerate() {
    return this.product.autoGenerate
  }

  private async loadProduct() {
    if (this.routeProductId != null) {
      try {
        this.$store.commit(MutationTypes.SET_LOADING, true)
        const response = await ApiClient.getProduct(this.routeProductId)
        this.product = Object.assign({}, this.product, response)
        this.updateNavigatorTabTitle()
        this.completeProduct(this.product)
      } catch (e) {
        console.log(e)
      } finally {
        this.$store.commit(MutationTypes.SET_LOADING, false)
      }
    }

    if (this.product.relatedToDigital != null) {
      try {
        const response = await ApiClient.getProduct(this.product.relatedToDigital)
        this.digitalCourse = Object.assign({}, this.digitalCourse, response)
      } catch (e) {
        console.log(e)
      }
    }
  }

  private updateNavigatorTabTitle() {
    const productName = `${this.product.code} - ${this.product.name}`
    document.title = productName
    this.$route.meta.title = productName
  }

  private completeProduct(product: Product) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this
    product.elements.forEach(function(element: Element) {
      if (vm.elementStatusFilesGrouped != null && vm.elementStatusFilesGrouped[parseInt(element.id)]) {
        Vue.set(element, 'elementStatusFiles', vm.elementStatusFilesGrouped[element.id])
      }
      vm.completeElement(element)
    })
  }

  private completeElement(element: Element) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this
    element.elements.forEach(function(element: Element) {
      if (vm.elementStatusFilesGrouped != null && vm.elementStatusFilesGrouped[parseInt(element.id)]) {
        Vue.set(element, 'elementStatusFiles', vm.elementStatusFilesGrouped[element.id])
      }
      vm.completeElement(element)
    })
  }

  private async loadElementTypes() {
    await this.$store.dispatch(ActionTypes.LOAD_ELEMENT_TYPES)
  }

  private async loadCountry() {
    await CvValueUtils.getCvValuesByType(CV_VALUE_COUNTRY)
  }

  private async loadBusinessUnit() {
    await CvValueUtils.getCvValuesByType(CV_VALUE_EDITORIAL_PROJECT_BUSINESS_UNIT)
  }

  private async loadProductionModes() {
    await CvValueUtils.getCvValuesByType(CV_VALUE_PRODUCTION_MODE)
  }

  private async loadEducationLevels() {
    await CvValueUtils.getCvValuesByType(CV_VALUE_EDUCATION)
  }

  private async loadProductTypes() {
    await CvValueUtils.getCvValuesByType(CV_VALUE_TYPE_PROD)
  }

  async loadFileStatus() {
    try {
      this.$store.commit(MutationTypes.SET_LOADING, true)
      const elementStatusFiles = await ApiClient.getElementStatus(this.routeProductId)
      this.elementStatusFiles = elementStatusFiles

      const elementStatusFilesGrouped = _.groupBy(elementStatusFiles, 'elementId')
      this.elementStatusFilesGrouped = elementStatusFilesGrouped
    } finally {
      this.$store.commit(MutationTypes.SET_LOADING, false)
    }
  }

  private elementCreated() {
    this.loadProduct()
  }

  private tabSelect(tabIndex: number) {
    this.$router.replace(
      {
        query: Object.assign({ ...this.$route.query }, { tab: tabIndex })
      }
    )
  }

  private getCvValueProductIcon(codeId: string) {
    const cvValue = CvValueUtils.getCvValue(codeId, CV_VALUE_TYPE_PROD)
    if (!cvValue || !cvValue.icon) {
      return DEFAULT_ICON_PRODUCT
    }
    return cvValue.icon
  }

  private getCvValueName(codeId: string, type: string = CV_VALUE_COUNTRY) {
    const typeName = CvValueUtils.getCvValueName(codeId, type)
    if (typeName === codeId) {
      return ''
    }
    return typeName
  }
}
